import { historyFailed, historyPaymentAlerts, isPaid, sessionAlerts, sessionPaymentAlerts } from "./alerts";

export const ALERTS = Object.freeze({ ALL: "all", WITH: "with", WITHOUT: "without" });
export const PAYMENTS = Object.freeze({ ALL: "all", WITH: "with", WITHOUT: "without" });
export const EMPTY = Object.freeze({ ALL: "all", HIDE: "hide", ONLY: "only" });

const STORAGE_KEY = "app_charges_filters";

export function emptyFilters() {
    return { alerts: ALERTS.ALL, payments: PAYMENTS.ALL, empty: EMPTY.ALL, points: [], search: "" };
}

export function hasFilters(filters) {
    return filters.alerts != ALERTS.ALL || filters.payments != PAYMENTS.ALL || filters.empty != EMPTY.ALL || filters.points.length > 0 || filters.search.trim() != "";
}

// Carregamento vazio: liberado sem transação, pagamento ou usuário e que não chegou a carregar
export function isEmptyCharge({ transactionId, paid, user, nfc, minutesCharger }) {
    return !transactionId && !paid && !user && !nfc && !(minutesCharger > 0);
}

function matchAlert(filters, hasAlert) {
    if (filters.alerts == ALERTS.WITH) return hasAlert;
    if (filters.alerts == ALERTS.WITHOUT) return !hasAlert;
    return true;
}

function matchPayment(filters, paid) {
    if (filters.payments == PAYMENTS.WITH) return paid;
    if (filters.payments == PAYMENTS.WITHOUT) return !paid;
    return true;
}

function matchEmpty(filters, empty) {
    if (filters.empty == EMPTY.HIDE) return !empty;
    if (filters.empty == EMPTY.ONLY) return empty;
    return true;
}

function pointName(charger) {
    return charger && charger.point ? charger.point.name : null;
}

function matchSearch(search, values) {
    const term = search.trim().toLowerCase();
    return term == "" || values.some((value) => value && String(value).toLowerCase().includes(term));
}

function matchPoint(filters, charger) {
    return filters.points.length == 0 || filters.points.includes(pointName(charger));
}

export function matchSession(session, filters) {
    return (
        matchAlert(filters, sessionAlerts(session).any || sessionPaymentAlerts(session).length > 0) &&
        matchPayment(filters, isPaid(session)) &&
        matchEmpty(filters, isEmptyCharge({ ...session, paid: isPaid(session) })) &&
        matchPoint(filters, session.charger) &&
        matchSearch(filters.search, [session.charger.name, session.user && session.user.email, session.nfc, session.transactionId])
    );
}

export function matchHistory(item, filters) {
    return (
        matchAlert(filters, historyFailed(item) || historyPaymentAlerts(item).length > 0) &&
        matchPayment(filters, isPaid(item)) &&
        matchEmpty(filters, isEmptyCharge({ ...(item.car || {}), transactionId: item.transactionId, user: item.user, paid: isPaid(item) })) &&
        matchPoint(filters, item.charger) &&
        matchSearch(filters.search, [item.charger && item.charger.name, item.user && item.user.email, item.car && item.car.nfc, item.transactionId])
    );
}

// Item da lista unificada (shared/charges.js)
export function matchCharge(item, filters) {
    return (
        matchAlert(filters, item.alert) &&
        matchPayment(filters, item.paid) &&
        matchEmpty(filters, isEmptyCharge(item)) &&
        matchPoint(filters, item.charger) &&
        matchSearch(filters.search, [item.charger && item.charger.name, item.user && item.user.email, item.nfc, item.transactionId])
    );
}

export function pointsOf(list) {
    return list.map((item) => pointName(item.charger)).filter(Boolean);
}

// Filtros salvos na URL para cada TV manter sua configuração ao recarregar
export function filtersFromQuery(query) {
    const points = query.point ? [].concat(query.point) : [];
    const alerts = query.alerts == "1" ? ALERTS.WITH : query.alerts == "0" ? ALERTS.WITHOUT : ALERTS.ALL;
    const payments = query.pay == "1" ? PAYMENTS.WITH : query.pay == "0" ? PAYMENTS.WITHOUT : PAYMENTS.ALL;
    const empty = query.empty == "1" ? EMPTY.ONLY : query.empty == "0" ? EMPTY.HIDE : EMPTY.ALL;
    return { alerts, payments, empty, points, search: query.q || "" };
}

export function filtersToQuery(filters) {
    const query = {};
    if (filters.alerts != ALERTS.ALL) query.alerts = filters.alerts == ALERTS.WITH ? "1" : "0";
    if (filters.payments != PAYMENTS.ALL) query.pay = filters.payments == PAYMENTS.WITH ? "1" : "0";
    if (filters.empty != EMPTY.ALL) query.empty = filters.empty == EMPTY.ONLY ? "1" : "0";
    if (filters.points.length > 0) query.point = filters.points;
    if (filters.search.trim() != "") query.q = filters.search.trim();
    return query;
}

const QUERY_KEYS = ["alerts", "pay", "empty", "point", "q", "view"];

// A URL tem prioridade (links e TVs configuradas), sem parâmetros usa a última escolha salva no navegador
export function loadQuery(query) {
    if (QUERY_KEYS.some((key) => query[key] != null)) return query;
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
        return {};
    }
}

export function saveQuery(query) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(query));
}
